var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Interface/Caret down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2855 10.4648C19.6273 10.8065 19.6273 11.3605 19.2855 11.7022L14.6189 16.3689C14.2772 16.7106 13.7232 16.7106 13.3814 16.3689L8.71478 11.7022C8.37307 11.3605 8.37307 10.8065 8.71478 10.4648C9.05649 10.1231 9.61051 10.1231 9.95221 10.4648L14.0002 14.5127L18.0481 10.4648C18.3898 10.1231 18.9438 10.1231 19.2855 10.4648Z",
    fill: "#909195"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowGray);
export default __webpack_public_path__ + "static/media/dropdown-arrow-gray.bedc7d00f07ef3262544413dba538fc3.svg";
export { ForwardRef as ReactComponent };